export const authConnection = (state) => {
  return state.authConnection;
};
